<template>
  <el-dialog
    :title="!dataForm.id ? '新增销售订单' : '修改销售订单'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客户类型" prop="customerType">
            <el-radio-group v-model="dataForm.customerType" @change="customerTypeChange">
              <el-radio label="WALK_IN">散客</el-radio>
              <el-radio label="MEMBER">会员</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付方式" prop="paymentMethod">
            <el-select v-model="dataForm.paymentMethod" placeholder="请选择支付方式">
              <el-option label="现金" value="CASH"></el-option>
              <el-option label="微信" value="WECHAT"></el-option>
              <el-option label="支付宝" value="ALIPAY"></el-option>
              <el-option label="会员余额" value="MEMBER_BALANCE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 散客信息 -->
      <div v-if="dataForm.customerType === 'WALK_IN'">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户姓名" prop="customerName">
              <el-input v-model="dataForm.customerName" placeholder="请输入客户姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户电话" prop="customerPhone">
              <el-input v-model="dataForm.customerPhone" placeholder="请输入客户电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      
      <!-- 会员信息 -->
      <div v-if="dataForm.customerType === 'MEMBER'">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="会员搜索" prop="memberId">
              <el-input 
                v-model="memberSearchKeyword" 
                placeholder="请输入会员姓名或电话搜索"
                @input="searchMembers"
                clearable>
                <el-button slot="append" icon="el-icon-search" @click="searchMembers"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="showMemberList = true">选择会员</el-button>
          </el-col>
        </el-row>
        
        <!-- 会员选择弹窗 -->
        <el-dialog
          title="选择会员"
          :visible.sync="showMemberList"
          width="800px"
          append-to-body>
          <el-table
            :data="memberList"
            @selection-change="memberSelectionChange"
            style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="username" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="balance" label="余额">
              <template slot-scope="scope">
                ¥{{ scope.row.balance || 0 }}
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showMemberList = false">取消</el-button>
            <el-button type="primary" @click="selectMember">确定</el-button>
          </div>
        </el-dialog>
      </div>
      
      <!-- 产品选择 -->
      <el-divider content-position="left">产品选择</el-divider>
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form-item label="产品搜索">
            <el-input 
              v-model="productSearchKeyword" 
              placeholder="请输入产品名称或编码搜索"
              @input="searchProducts"
              clearable>
              <el-button slot="append" icon="el-icon-search" @click="searchProducts"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showProductList = true">选择产品</el-button>
        </el-col>
      </el-row>
      
      <!-- 产品选择弹窗 -->
      <el-dialog
        title="选择产品"
        :visible.sync="showProductList"
        width="1000px"
        append-to-body>
        <el-table
          :data="productList"
          @selection-change="productSelectionChange"
          style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="productName" label="产品名称"></el-table-column>
          <el-table-column prop="productCode" label="产品编码"></el-table-column>
          <el-table-column prop="category" label="分类"></el-table-column>
          <el-table-column prop="salePrice" label="销售价">
            <template slot-scope="scope">
              ¥{{ scope.row.salePrice }}
            </template>
          </el-table-column>
          <el-table-column prop="currentStock" label="库存">
            <template slot-scope="scope">
              {{ scope.row.currentStock || 0 }}
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showProductList = false">取消</el-button>
          <el-button type="primary" @click="addSelectedProducts">确定</el-button>
        </div>
      </el-dialog>
      
      <!-- 已选产品列表 -->
      <el-table
        :data="selectedProducts"
        style="width: 100%; margin-top: 10px;">
        <el-table-column prop="productName" label="产品名称"></el-table-column>
        <el-table-column prop="productCode" label="产品编码"></el-table-column>
        <el-table-column prop="salePrice" label="单价">
          <template slot-scope="scope">
            ¥{{ scope.row.salePrice }}
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="120">
          <template slot-scope="scope">
            <el-input-number 
              v-model="scope.row.quantity" 
              :min="1" 
              :max="scope.row.currentStock"
              @change="calculateTotal">
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="discountAmount" label="折扣" width="120">
          <template slot-scope="scope">
            <el-input-number 
              v-model="scope.row.discountAmount" 
              :min="0" 
              :max="scope.row.salePrice * scope.row.quantity"
              :precision="2"
              @change="calculateTotal">
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="subtotalAmount" label="小计">
          <template slot-scope="scope">
            ¥{{ scope.row.subtotalAmount }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeProduct(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 订单汇总 -->
      <el-divider content-position="left">订单汇总</el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="总金额">
            <span style="font-size: 18px; color: #409EFF;">¥{{ dataForm.totalAmount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="折扣金额">
            <span style="font-size: 18px; color: #67C23A;">¥{{ dataForm.discountAmount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实付金额">
            <span style="font-size: 20px; color: #E6A23C; font-weight: bold;">¥{{ dataForm.actualAmount }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          customerType: 'WALK_IN',
          customerId: null,
          customerName: '',
          customerPhone: '',
          totalAmount: 0,
          discountAmount: 0,
          actualAmount: 0,
          paymentMethod: 'CASH',
          remark: ''
        },
        dataRule: {
          customerType: [
            { required: true, message: '客户类型不能为空', trigger: 'change' }
          ],
          paymentMethod: [
            { required: true, message: '支付方式不能为空', trigger: 'change' }
          ]
        },
        memberSearchKeyword: '',
        memberList: [],
        showMemberList: false,
        selectedMember: null,
        productSearchKeyword: '',
        productList: [],
        showProductList: false,
        selectedProducts: [],
        tempSelectedProducts: []
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: `saleorder/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm = data.data
              }
            })
          } else {
            this.resetForm()
          }
        })
      },
      resetForm () {
        this.dataForm = {
          id: 0,
          customerType: 'WALK_IN',
          customerId: null,
          customerName: '',
          customerPhone: '',
          totalAmount: 0,
          discountAmount: 0,
          actualAmount: 0,
          paymentMethod: 'CASH',
          remark: ''
        }
        this.selectedProducts = []
        this.selectedMember = null
      },
      customerTypeChange () {
        if (this.dataForm.customerType === 'WALK_IN') {
          this.dataForm.customerId = null
          this.dataForm.customerName = ''
          this.dataForm.customerPhone = ''
        } else {
          this.dataForm.customerName = ''
          this.dataForm.customerPhone = ''
        }
      },
      searchMembers () {
        const keyword = (this.memberSearchKeyword || '').trim()
        if (!keyword) {
          this.memberList = []
          return
        }
        this.$http({
          url: 'yonghu/search',
          method: 'get',
          params: { keyword }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.memberList = Array.isArray(data.data) ? data.data : (data.data?.list || [])
          } else {
            this.memberList = []
          }
        }).catch(() => {
          this.memberList = []
        })
      },
      memberSelectionChange (selection) {
        this.selectedMember = selection.length > 0 ? selection[0] : null
      },
      selectMember () {
        if (this.selectedMember) {
          this.dataForm.customerId = this.selectedMember.id
          this.dataForm.customerName = this.selectedMember.username
          this.dataForm.customerPhone = this.selectedMember.phone
          this.showMemberList = false
        } else {
          this.$message.warning('请选择一个会员')
        }
      },
      searchProducts () {
        if (!this.productSearchKeyword.trim()) {
          this.productList = []
          return
        }
        this.$http({
          url: 'product/page',
          method: 'get',
          params: {
            page: 1,
            limit: 20,
            productName: this.productSearchKeyword
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.productList = data.data.list || []
          }
        })
      },
      productSelectionChange (selection) {
        this.tempSelectedProducts = selection
      },
      addSelectedProducts () {
        if (!this.tempSelectedProducts || this.tempSelectedProducts.length === 0) {
          this.$message.warning('请选择产品')
          return
        }
        
        // 添加产品到已选列表
        this.tempSelectedProducts.forEach(product => {
          const existingIndex = this.selectedProducts.findIndex(p => p.productId === product.id)
          if (existingIndex === -1) {
            this.selectedProducts.push({
              productId: product.id,
              productName: product.productName,
              productCode: product.productCode,
              salePrice: product.salePrice,
              currentStock: product.currentStock || 0,
              quantity: 1,
              discountAmount: 0,
              subtotalAmount: product.salePrice
            })
          }
        })
        
        this.calculateTotal()
        this.showProductList = false
      },
      removeProduct (index) {
        this.selectedProducts.splice(index, 1)
        this.calculateTotal()
      },
      calculateTotal () {
        let totalAmount = 0
        let totalDiscount = 0
        
        this.selectedProducts.forEach(product => {
          product.subtotalAmount = (product.salePrice * product.quantity) - product.discountAmount
          totalAmount += product.salePrice * product.quantity
          totalDiscount += product.discountAmount
        })
        
        this.dataForm.totalAmount = totalAmount
        this.dataForm.discountAmount = totalDiscount
        this.dataForm.actualAmount = totalAmount - totalDiscount
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            if (this.selectedProducts.length === 0) {
              this.$message.warning('请至少选择一个产品')
              return
            }
            
            const params = {
              ...this.dataForm,
              details: this.selectedProducts.map(product => ({
                productId: product.productId,
                quantity: product.quantity,
                unitPrice: product.salePrice,
                discountAmount: product.discountAmount,
                subtotalAmount: product.subtotalAmount
              }))
            }
            
            this.$http({
              url: 'saleorder/create',
              method: 'post',
              data: params
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
